import MagicMenu from './MagicMenu';

export default MagicMenu;
